import { Alert, AlertTitle } from "@/components/ui/alert"
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline"

/**
 * A component that displays an error message in the subscribe modal.
 */
export default function ErrorAlert({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <Alert
      variant="destructive"
      className="h-10 p-1 flex items-center rounded-sm"
    >
      <AlertTitle className="text-sm mt-1 flex items-center">
        <ExclamationTriangleIcon className="h-4 w-4 ml-2 mr-3 mt-0.5" />

        {children}
      </AlertTitle>
    </Alert>
  )
}
